import { checkReservationExists, checkWorker, getReservationsByTask } from "../../ActionUtils";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { CbmImpl } from "~/modules/cbm";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendWorkerTrackingEvent } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { Action, TaskReservation } from "~/modules/actions/Action";
import { RejectOptions } from "~/packages/taskrouter/types";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";




export interface RejectTaskOptions extends RejectOptions {}





























export class RejectTask implements Action<Promise<TaskReservation>> {
    


    readonly #taskSid: string;

    


    readonly #options?: RejectTaskOptions;

    constructor(taskSid: string, options?: RejectTaskOptions) {
        this.#taskSid = taskSid;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        logger.debug(`rejectTask invoked with taskSid: ${this.#taskSid}`);

        checkWorker(worker, {
            actionName: "RejectTask",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.RejectTaskCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "pending");

        checkReservationExists(reservation, this.#taskSid, {
            actionName: "RejectTask",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.RejectTaskCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const validReservation = reservation!;

        try {
            await cbm.rejectReservation(validReservation, this.#options);
            sendWorkerTrackingEvent(EVENTS.RejectTaskCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            });
            return { task: validReservation.task, reservation: validReservation };
        } catch (error) {
            const errorMsg = `RejectTask: Failed to reject reservation ${validReservation.sid} for task ${
                this.#taskSid
            }`;
            logger.error(errorMsg, error);
            sendWorkerTrackingEvent(EVENTS.RejectTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.FailedToRejectReservation,
                    { severity: ErrorSeverity.Error },
                    errorMsg,
                    error
                )
            );
        }
    }
}
